import type { DefaultOptionType } from 'antd/es/select';
import type { ShipmentCategoryTypeResponse } from './api';

export const normalizeShipmentCategoryType = (list: ShipmentCategoryTypeResponse): DefaultOptionType[] => {
  if (!list) {
    return [];
  }
  return list.map((row) => ({
    label: row.hierLookupName,
    value: row.hierLookupDetKey,
  }));
};
